export default "__VITE_ASSET__5ebb3269__"